import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardHeader from "../Other/DashboardHeader";
import PageContainer from "../pages/PageContainer";
import PageHeader from "../PageHeader";
import CustomPageHeader from "../pages/CustomPageHeader";
import { useTranslation } from "react-i18next";

const tabStyles = {
  base: "flex-1 py-2 font-semibold text-center rounded-lg cursor-pointer",
  active: "bg-purple-700 text-white",
  inactive: "bg-white text-gray-500",
};

const VibeMembers = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const members = Array.isArray(location.state?.members)
    ? location.state.members
    : [];
  const [activeTab, setActiveTab] = useState("accepted");

  const { t } = useTranslation();

  // Filter members by status
  const filteredMembers = members.filter((m) => {
    if (activeTab === "accepted") return m.status === 1;
    if (activeTab === "rejected") return m.status === 2;
    if (activeTab === "pending") return m.status === 0;
    return true;
  });

  return (
    <>
      <CustomPageHeader
        pageContainerClass="py-5"
        title={t("members", "Vibelinks")}
        // hideBack={true}
        // showPageHeader={false}
      >
<div className="min-h-screen bg-gray-50 dark:bg-black transition-colors duration-300">

  {/* Header */}
  <div className="flex items-center p-4 border-b bg-white dark:bg-black border-gray-200 dark:border-[#1c1c1c]">
    {/* You can add back buttons or titles here */}
  </div>

  {/* Tabs */}
  <div className="flex justify-center mt-4 mb-4 gap-2 px-4">
    <button
      className={`${tabStyles.base} ${
        activeTab === "accepted"
          ? tabStyles.active
          : `${tabStyles.inactive} bg-white text-gray-700 dark:bg-[#1a1a2e] dark:text-gray-300`
      }`}
      onClick={() => setActiveTab("accepted")}
    >
      {t("accepted", "Accepted")}
    </button>

    <button
      className={`${tabStyles.base} ${
        activeTab === "rejected"
          ? tabStyles.active
          : `${tabStyles.inactive} bg-white text-gray-700 dark:bg-[#1a1a2e] dark:text-gray-300`
      }`}
      onClick={() => setActiveTab("rejected")}
    >
      {t("rejected", "Rejected")}
    </button>

    <button
      className={`${tabStyles.base} ${
        activeTab === "pending"
          ? tabStyles.active
          : `${tabStyles.inactive} bg-white text-gray-700 dark:bg-[#1a1a2e] dark:text-gray-300`
      }`}
      onClick={() => setActiveTab("pending")}
    >
      {t("pending", "Pending")}
    </button>
  </div>

  {/* Member Cards */}
  <div className="px-4">
    {filteredMembers.length === 0 ? (
      <div className="text-gray-500 dark:text-gray-300 text-center mt-8">
        {t("no_members_found", "No members found.")}
      </div>
    ) : (
      filteredMembers.map((m, idx) => (
        <div
          key={m.id || idx}
          className="flex items-center bg-white dark:bg-[#252739] hover:bg-gray-50 dark:hover:bg-[#2f3050] rounded-xl shadow-sm border border-gray-200 dark:border-[#1a1a2e] mb-4 p-3 vibe-members-card transition-all duration-200"
        >
          <img
            src={
              m.user?.image ||
              m.image ||
              "/default-image.jpg"
            }
            alt={m.user?.full_name || m.user?.user_name || m.name || "User"}
            className="w-12 h-12 rounded-full object-cover mr-4 border border-gray-300 dark:border-[#2a2a3c]"
          />
          <span className="font-semibold text-lg text-gray-900 dark:text-white">
            {m.user?.full_name || m.user?.user_name || m.name}
          </span>
        </div>
      ))
    )}
  </div>
</div>


      </CustomPageHeader>
    </>
  );
};

export default VibeMembers;
